<div class="wl-board-wrap">
  <!-- El sprint es el marco del tablero, no un tema aparte: su estado, ventana, objetivo y carga
       viven aquí arriba desde que se retiró la pestaña «Sprints». -->
  <app-worklog-sprint-bar *ngIf="!loading" [sprint]="board.sprint" [isDev]="isDev" [columns]="board.columns"
    (changed)="reload()" (openItem)="openItem.emit($event)"></app-worklog-sprint-bar>

  <!-- Skeleton del tablero: la cabecera del sprint y las seis columnas con sus tarjetas. Se
       reservan las columnas completas porque el tablero es ancho — un spinner centrado deja la
       pantalla en blanco y luego mete seis columnas de golpe. -->
  <div class="sk-board" *ngIf="loading" aria-busy="true" aria-label="Cargando tablero">
    <div class="sk-sprint">
      <p-skeleton height="1.3rem" width="11rem"></p-skeleton>
      <p-skeleton height="0.8rem" width="22rem"></p-skeleton>
      <p-skeleton height="3px" width="100%" borderRadius="999px"></p-skeleton>
    </div>
    <div class="wl-board">
      <div class="wl-col" *ngFor="let c of [1,2,3,4,5,6]" [ngClass]="'sk-fade-' + (c > 4 ? 4 : c)">
        <div class="sk-col-head">
          <p-skeleton height="0.8rem" width="6rem"></p-skeleton>
          <p-skeleton shape="circle" size="1.1rem"></p-skeleton>
        </div>
        <div class="sk-col-body">
          <div class="sk-card" *ngFor="let k of [1,2]">
            <p-skeleton height="0.7rem" width="3.5rem"></p-skeleton>
            <p-skeleton height="0.8rem" width="90%"></p-skeleton>
            <p-skeleton height="0.8rem" width="60%"></p-skeleton>
            <p-skeleton height="0.6rem" width="4rem" borderRadius="999px"></p-skeleton>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Tablero -->
  <div class="wl-board" *ngIf="!loading && board.sprint">
    <div class="wl-col" *ngFor="let status of COLUMNS"
      pDroppable="board"
      [class.drop-ok]="dropTarget === status"
      (onDrop)="onDrop(status)"
      (onDragEnter)="onDragEnter(status)"
      (onDragLeave)="onDragLeave()">
      <!-- Cabecera de columna ("Por hacer" no es un estado: su meta sale de colMeta) -->
      <div class="wl-col-head" [style.--c]="colMeta(status).color" [title]="colMeta(status).label">
        <span class="wl-col-name">
          <i [class]="colMeta(status).icon"></i> <span class="wl-col-lbl">{{ colMeta(status).label }}</span>
        </span>
        <span class="wl-col-count">{{ column(status).length }}</span>
      </div>

      <!-- Tarjetas -->
      <div class="wl-col-body">
        <!-- El acento del borde izquierdo lleva el color del tipo: deja leer de un vistazo dónde
             hay bugs en una columna, sin tener que recorrer los íconos uno por uno. -->
        <div class="wl-card" *ngFor="let it of column(status); trackBy: trackId"
          pDraggable="board"
          [class.draggable]="isDev"
          [style.--accent]="TYPE_META[it.type].color"
          (onDragStart)="onDragStart(it)"
          (onDragEnd)="onDragEnd()"
          (click)="openItem.emit(it._id)">
          <!-- Fila de identificación: tipo y folio, discretos. El título es lo que se lee. -->
          <div class="wl-card-top">
            <span class="wl-card-type" [style.color]="TYPE_META[it.type].color" [title]="TYPE_META[it.type].label">
              <i [class]="TYPE_META[it.type].icon"></i>
            </span>
            <span class="wl-code" *ngIf="it.code">{{ it.code }}</span>
            <span class="wl-card-flags">
              <!-- La severidad de un bug decide si se atiende hoy: estaba solo en el detalle. -->
              <span class="wl-card-sev" *ngIf="it.type === 'bug' && it.severity" [style.color]="SEVERITY_META[it.severity].color"
                [title]="'Severidad ' + SEVERITY_META[it.severity].label">{{ SEVERITY_META[it.severity].label }}</span>
              <span class="wl-card-prio" *ngIf="it.priority" [style.color]="PRIORITY_META[it.priority].color"
                [title]="'Prioridad ' + PRIORITY_META[it.priority].label">
                <i [class]="PRIORITY_META[it.priority].icon"></i>
              </span>
            </span>
          </div>
          <p class="wl-card-title">{{ it.title }}</p>
          <!-- A qué frente del Roadmap pertenece. Sin esto la tarjeta no dice para qué es la tarea. -->
          <span class="wl-card-epic" *ngIf="epicTitle(it)" [title]="'Épica: ' + epicTitle(it)">
            <i class="fa-solid fa-layer-group"></i> {{ epicTitle(it) }}
          </span>
          <div class="wl-card-tags" *ngIf="it.areas?.length">
            <span class="wl-area" *ngFor="let a of it.areas" [style.background]="areaMeta(a)?.color + '1a'"
              [style.color]="areaMeta(a)?.color">{{ areaMeta(a)?.short }}</span>
          </div>
          <div class="wl-card-foot">
            <span class="wl-pts" *ngIf="it.points != null">{{ it.points }} pts</span>
            <!-- Aging: cuántos días lleva parada en ESTA columna. Se tiñe al pasar los umbrales. En
                 Terminadas no aplica: ahí no se atora nada. -->
            <span class="wl-aging" *ngIf="it.stageDays != null && status !== DONE_COLUMN" [class]="'is-' + agingLevel(it)"
              [title]="'Sin moverse desde ' + (it.stageSince | date: 'dd MMM, HH:mm')">
              <i class="fa-regular fa-clock"></i> {{ agingLabel(it) }}
            </span>
            <span class="ava" *ngIf="it.assignee" [title]="userName(it.assignee)">{{ initials(it.assignee) }}</span>
          </div>
        </div>

        <div class="wl-col-empty" *ngIf="!column(status).length">—</div>
      </div>
    </div>
  </div>
</div>
